<template>
<div class="container">
  <br>
  <div class="row" style="color:red;">
    ** Please contact wholesaler from your state.
  </div>
  <br>

  <div class="row">
    <select class="form-control form-select col-sm-5 text-left" v-model="stateSel">
      <option v-for="state in stateList" :key="state">
        {{ state }}
      </option>
    </select>
  </div>
  <br>
  <div class="row">
    <button class="btn btn-success col-sm-2" @click="getWholesalers">Get List</button>
  </div>

  <br>
  <br>
  <table id="cart" class="table table-hover table-sm">
    <thead>
      <tr>
        <th style="width:30%">Name</th>
        <th style="width:10%">Phone</th>
        <th style="width:60%">Address</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="wholesaler in wholesalerList" :key="wholesaler.name">
      <td>{{ wholesaler.name }}</td>  
       <td>{{ wholesaler.phone }}</td> 
       <td>{{ wholesaler.address }}</td>  
    </tr>
    </tbody>

    <tfoot>
    </tfoot>
  </table>
    
  <hr>
  <h6>{{ message }}</h6>


</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex';

import { DB } from '../config/firebaseConfig'
import { collection, query, where, orderBy, limit, getDocs } from "firebase/firestore"
import { anonSignIn } from '../config/firebaseConfig.js';

export default {
  name: 'Wholesalers',

  components: {
  },

  created() {
  },

  mounted(){
  },

  data() {
    return {
      wholesalerList: [],
      message: '',

			stateList: ["Andhra Pradesh","Andaman and Nicobar Islands","Arunachal Pradesh","Assam","Bihar",
						"Chandigarh","Chhattisgarh","Dadar and Nagar Haveli","Daman and Diu","Delhi","Lakshadweep",
						"Puducherry","Goa","Gujarat","Haryana","Himachal Pradesh","Jammu and Kashmir","Jharkhand",
						"Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram",
						"Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura",
						"Uttar Pradesh","Uttarakhand","West Bengal"],
			stateSel: "Maharashtra",
    }
  },

  computed: {
    ...mapGetters(['orgId', 'orgName']),
  },

  methods: {
    ...mapActions(['authStatusChange']),

      //Get wholesalers from db
      async getWholesalers(){
        var self = this
        self.wholesalerList = []
        self.message = ''
        let state = self.stateSel.toLowerCase()

        const tokens = await anonSignIn()
        if (tokens.auth == ''){
          self.addMessage({messageClass: 'error', message: "Invalid User",})
          return
        } else {
          self.authStatusChange()
        }

        const q = query(collection(DB, "Org", self.orgId, "CustomerOrders"), 
                        where("state", "==", state), 
                        orderBy("amt", "desc"),
                        limit(10)
                       );

        const querySnapshot = await getDocs(q)
        await querySnapshot.forEach((doc) => {
          if (doc.data().amt > 25000)
            self.wholesalerList.push({'name': doc.data().customer, 'phone': doc.data().phone, 'address': doc.data().address})
        })
        if (self.wholesalerList.length==0)
          self.message = "No wholesalers found in this state."

      },

  }
}
</script>

<style>
.loadingItem {
  align-items: center;
  justify-content: center;
  display: flex;
}

.action-panel {
  margin-bottom: 10px;
  margin-right: 5px;
}
</style>
